<template>
  <v-card class="pa-2" flat>
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tab-item v-for="(ac, i) in items" :key="i">
          <v-card-title>{{ ac.title }}</v-card-title>
          <v-card flat class="pa-2 w-100 d-flex flex-wrap">
            <template v-for="(app, i) in $data[ac.value]">
              <v-tooltip :key="i" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-hover v-slot="{ hover }">
                    <div
                      @click="addApplications(app, i)"
                      style="cursor: pointer"
                      v-bind="attrs"
                      :style="{ background: hover ? app.attrs.bgColor : '' }"
                      v-on="on"
                      class="qrBtn ma-2"
                    >
                      <component
                        :is="app.component"
                        v-bind="hover ? app.attrs : ''"
                        :height="app.height"
                        :width="app.width"
                      />
                    </div>
                  </v-hover>
                </template>
                <span>{{ app?.title }}</span>
              </v-tooltip>
            </template>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <custom-application
            v-model="customApplication"
            :links="links"
            @click="addApplications"
          />
        </v-tab-item>
      </template>
    </custom-tabs>

    <v-divider></v-divider>

    <v-card-text
      v-for="(link, i) in Object.keys(links)"
      v-show="links[link]?.data?.length > 0"
      :key="i"
      class="pa-2"
    >
      <div class="d-flex align-items-center">
        <component
          v-if="!!links[link]?.svg?.cm"
          :is="links[link]?.svg?.cm"
          :height="links[link]?.svg?.height"
          :width="links[link]?.svg?.width"
        ></component>
        <div
          v-else-if="!!links[link]?.svg?.img"
          style="height: 30px; width: 30px"
        >
          <v-img :src="links[link]?.svg?.img" height="30" width="30" />
        </div>

        <v-btn
          fab
          small
          v-else-if="!!links[link]?.svg?.color"
          class="elevation-0"
          :style="{ background: links[link]?.svg?.color }"
        />
        <v-subheader>{{ links[link]?.title }}</v-subheader>
      </div>
      <div v-for="(data, j) in links[link]?.data" :key="j">
        <v-text-field
          v-model="data.value"
          dense
          outlined
          :placeholder="data.placeholder"
          :label="data.label"
          clearable
          :append-icon="data?.icon ?? 'mdi-apps'"
          prepend-icon="mdi-delete"
          @click:prepend="links[link].data.splice(j, 1)"
        />
      </div>
      <v-divider v-if="Object.keys(links)?.length > i" />
    </v-card-text>
  </v-card>
</template>

<script>
import SvgBase from "../../../../content/svgLoader/svgBase.vue";
import svgBazar from "../cm/svgBazar.vue";
import svgWhatsapp from "../../../../content/svgLoader/svgFile/svgWhatsapp.vue";
import SvgMyket from "../cm/svgMyket.vue";
import svgAppstore from "../cm/svgAppstore.vue";
import svgGoogleplay from "../cm/svgGoogleplay.vue";
import svgSamsungstore from "../cm/svgSamsungstore.vue";
import svgXhiame from "../cm/svgXhiame.vue";
import svgVivostore from "../cm/svgVivostore.vue";
import svgAmazonstore from "../cm/svgAmazonstore.vue";
import customApplication from "./customApplication.vue";
export default {
  name: "choseApplication",
  components: {
    svgBazar,
    SvgBase,
    svgWhatsapp,
    SvgMyket,
    svgAppstore,
    svgGoogleplay,
    svgSamsungstore,
    svgXhiame,
    svgVivostore,
    svgAmazonstore,
    customApplication,
  },
  props: {
    value: [Object],
  },

  data() {
    return {
      items: [
        {
          title: this.$t("add_iranian_stores"),
          value: "persianApplication",
        },
        {
          title: this.$t("add_foreign_stores"),
          value: "englishApplication",
        },
      ],

      defLinks: {
        bazar: {
          title: this.$t("bazaar"),
          data: [],
          svg: {
            cm: "svgBazar",
            img: null,
            color: null,
            height: "50",
            width: "50",
          },
        },
        myket: {
          title: this.$t("myket"),
          data: [],
          svg: {
            cm: "svgMyket",
            img: null,
            color: null,
            height: "40",
            width: "40",
          },
        },
        appstore: {
          title: this.$t("app_store"),
          data: [],
          svg: {
            cm: "svgAppstore",
            img: null,
            color: null,
            height: "35",
            width: "35",
          },
        },
        googleplay: {
          title: this.$t("google_play"),
          data: [],
          svg: {
            cm: "svgGoogleplay",
            img: null,
            color: null,
            height: "25",
            width: "25",
          },
        },
        samsungStore: {
          title: this.$t("samsung_store"),
          data: [],
          svg: {
            cm: "svgSamsungstore",
            img: null,
            color: null,
            height: "30",
            width: "30",
          },
        },
        xhiameStore: {
          title: this.$t("xiaomi_store"),
          data: [],
          svg: {
            cm: "xhiameStore",
            img: null,
            color: null,
            height: "50",
            width: "50",
          },
        },
        vivoStore: {
          title: this.$t("vivo_store"),
          data: [],
          svg: {
            cm: "svgVivostore",
            img: null,
            color: null,
            height: "50",
            width: "50",
          },
        },
        amazonStore: {
          title: this.$t("amazon_store"),
          data: [],
          svg: {
            cm: "svgAmazonstore",
            img: null,
            color: null,
            height: "50",
            width: "50",
          },
        },
      },

      persianApplication: [
        {
          title: this.$t("bazaar"),
          name: "bazar",
          component: "svgBazar",
          attrs: { bgColor: "#40c351", fgColor: "#fff" },
          height: "80",
          width: "80",
          label: this.$t("bazaar_app"),
          placeholder: this.$t("bazaar_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/(www\.)?cafebazaar\.ir\/app\/[a-zA-Z0-9._-]+$/.test(
                v
              ) ||
              this.$t("bazaar_link_hint"),
          ],
        },
        {
          title: this.$t("myket"),
          name: "myket",
          component: "svgMyket",
          attrs: { bgColor: "#04acfc", fgColor: "#fff", ggColor: "#000" },
          height: "80",
          label: this.$t("myket_app"),
          placeholder: this.$t("myket_link_placeholder"),
          width: "80",
          rules: [
            (v) =>
              /^myket:\/\/details\?id=[a-zA-Z0-9._-]+$/.test(v) ||
              /^myket:\/\/download\/[a-zA-Z0-9._-]+$/.test(v) ||
              this.$t("myket_link_hint"),
          ],
        },
      ],

      englishApplication: [
        {
          title: this.$t("app_store"),
          name: "appstore",
          component: "svgAppstore",
          attrs: { bgColor: "#2494f4", fgColor: "#fff", ggColor: "#000" },
          height: "80",
          width: "80",
          label: this.$t("app_store_app"),
          placeholder: this.$t("app_store_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/apps\.apple\.com\/[a-z]{2}\/app\/[a-zA-Z0-9._-]+\/id\d+$/.test(
                v
              ) ||
              this.$t("app_store_link_hint"),
          ],
        },
        {
          title: this.$t("google_play"),
          name: "googleplay",
          component: "svgGoogleplay",
          attrs: { bgColor: "#fff" },
          label: this.$t("google_play_app"),
          placeholder: this.$t("google_play_link_placeholder"),
          height: "80",
          width: "80",
          rules: [
            (v) =>
              /^https?:\/\/play\.google\.com\/store\/apps\/details\?id=[a-zA-Z0-9._-]+$/.test(
                v
              ) ||
              this.$t("google_play_link_hint"),
          ],
        },
        {
          title: this.$t("samsung_store"),
          name: "samsungStore",
          component: "svgSamsungstore",
          attrs: { bgColor: "#ec3c75", fgColor: "#fff" },
          height: "40",
          width: "40",
          label: this.$t("samsung_store_app"),
          placeholder: this.$t("samsung_store_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/galaxy\.store\/[a-zA-Z0-9._-]+$/.test(v) ||
              this.$t("samsung_store_link_hint"),
          ],
        },
        {
          title: this.$t("xiaomi_store"),
          name: "xhiameStore",
          component: "svgXhiame",
          attrs: { bgColor: "#fc6c04", fgColor: "#fff" },
          height: "80",
          width: "80",
          label: this.$t("xiaomi_store_app"),
          placeholder: this.$t("xiaomi_store_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/global\.app\.mi\.com\/details\?id=[a-zA-Z0-9._-]+$/.test(
                v
              ) || this.$t("xiaomi_store_link_hint"),
          ],
        },
        {
          title: this.$t("vivo_app_store"),
          name: "vivoStore",
          component: "svgVivostore",
          attrs: { bgColor: "#0675bc", fgColor: "#000" },
          height: "80",
          width: "80",
          label: this.$t("vivo_app_store_app"),
          placeholder: this.$t("vivo_app_store_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/apps\.vivo\.com\/detail\/[a-zA-Z0-9._-]+$/.test(v) ||
              this.$t("vivo_app_store_link_hint"),
          ],
        },
        {
          title: this.$t("amazon_store"),
          name: "amazonStore",
          component: "svgAmazonstore",
          attrs: { bgColor: "#fc9c04", fgColor: "#fff" },
          height: "80",
          width: "80",
          label: this.$t("amazon_store_app"),
          placeholder: this.$t("amazon_store_link_placeholder"),
          rules: [
            (v) =>
              /^https?:\/\/www\.amazon\.com\/gp\/product\/[A-Z0-9]{10}$/.test(
                v
              ) || this.$t("amazon_store_link_hint"),
          ],
        },
      ],

      customApplication: [],

      tabItems: [
        { text: this.$t("iranian_store"), icon: "application-settings" },
        { text: this.$t("foreign_store"), icon: "application-settings-outline" },
        { text: this.$t("personal_store"), icon: "bag-personal-plus-outline" },
      ],
      tabs: null,
    };
  },

  methods: {
    addApplications(apps, i) {
      let app = {
        placeholder: apps?.placeholder,
        name: apps?.name,
        label: apps?.label,
        value: null,
        icon: "mdi-apps",
        svg: apps?.component,
        image: apps?.images,
        color: apps?.color,
        rules: apps?.rules,
      };

      this.links[apps.name].data.push(app);
    },
  },

  computed: {
    links: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    customApplication: {
      deep: true,
      handler(val) {
        if (!!val) {
          val?.map((item) => {
            if (!Object.hasOwn(this.links, item.name)) {
              this.links = {
                ...this.links,
                [item.name]: {
                  title: item?.title,
                  data: [],
                  svg: {
                    cm: null,
                    img: item?.images,
                    color: item?.color,
                    height: "50",
                    width: "50",
                  },
                },
              };
            }
          });
        }
      },
    },
  },
};
</script>

<style scoped>
.qrBtn {
  border-radius: 15px !important;
  box-shadow: 4px 3px 5px rgba(2, 16, 92, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  transition: all 0.15s ease-in-out;
}

.qrBtn:hover {
  border-radius: 8px !important;
  box-shadow: 8px 5px 10px #02105c8c !important;
}
</style>
